'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:env:getPageEnv');
}

var _invoke = require('../invoke');

/**
 * 获取当前页面变量
 *
 * 支持版本
 * + iHotel/6.3
 *
 * @memberof env
 * @static
 * @name getPageEnv
 * @return {Promise<version>}
 * @example
 *  hbnb.env.getPageEnv()
 *      .then(function(env) {
 *      });
 */

module.exports = function() {
    if (process.env.NODE_ENV !== 'production') {
        debug('called');
    }

    var p = new Promise(function(resolve, reject) {
        _invoke('env', 'get_page_env', {
            callback: function(env) {
                resolve(env);
            },
            errback: function(err) {
                reject(err);
            }
        });
    });
    return p;
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/env/get-page-env.js
// module id = 575
// module chunks = 0